import { ref, watch } from 'vue'

// Keep track of whether UTMs have been initialized
const isInitialized = ref(false)

export const initializeUtms = () => {
  if (isInitialized.value) return

  const userId = localStorage.getItem('quiz_user_id')
  if (!userId) return

  const currentUrl = new URL(window.location.href)
  const params = new URLSearchParams(currentUrl.search)

  // Add utm_id if not present
  if (!params.has('utm_id')) {
    params.set('utm_id', userId)

    // Update URL without reload
    const newUrl = `${window.location.pathname}?${params.toString()}`
    window.history.replaceState({}, '', newUrl)
  }

  isInitialized.value = true
}

// Watch for userId changes
export const setupUtmWatcher = () => {
  watch(() => localStorage.getItem('quiz_user_id'), (newUserId) => {
    if (newUserId && !isInitialized.value) {
      initializeUtms()
    }
  })
}